import { AUDIENCE_TEMPLATES_CONFIG, type AudienceTemplate } from '@/views/audience/config/templates.config'

export default function useAudienceTemplates() {
  const { t } = useI18n()

  const templates = computed<AudienceTemplate[]>(() =>
    AUDIENCE_TEMPLATES_CONFIG.map((template) => ({
      ...template,
      title: t(template.title),
      description: t(template.description)
    }))
  )

  const formattedTemplates = computed<AudienceTemplate[]>(() =>
    templates.value.filter((template) => !template.disabled)
  )

  const recommendedTemplates = computed<AudienceTemplate[]>(() =>
    formattedTemplates.value.filter((template) => template.isRecommended)
  )

  const categories = computed(() => [
    { id: 'all', label: t('pages.audience.templatesPage.filters.all') },
    { id: 'recommended', label: t('pages.audience.templatesPage.filters.recommended') },
    { id: 'attract_convert', label: t('pages.audience.templatesPage.filters.attract_convert') },
    { id: 'retain_reward', label: t('pages.audience.templatesPage.filters.retain_reward') },
    { id: 'reactivate_reengage', label: t('pages.audience.templatesPage.filters.reactivate_reengage') }
  ])

  return {
    categories,
    recommendedTemplates,
    templates: formattedTemplates
  }
}
